/* global jQuery COMPONENTS */

COMPONENTS.ComponentMenu = (function ($) {
  function ComponentMenu () {
    this.$component = $('[data-ecs-component="component-menu"]')
    this.$accordionElems = this.$component.find('[data-ecs-accordion]')
    this.$menuParents = this.$component.find('[data-ecs-parent-element]')
    const viewportLaptop = window.matchMedia('(min-width: 1024px)')

    // Find menu parent links, disable at desktop sizes on touchscreen devices
    this.$menuParents.each(function () {
      const parent = this
      parent.id = $(parent).attr('data-ecs-parent-element')
      parent.parentLink = $(parent).find('.ecs_menu_link').first() // Find the link object for the parent wrapper
      parent.parentMenu = $(parent).find('.ecs_accordion').first() // Find the menu object for the parent wrapper
      parent.toggle = function () {
        if (parent.parentMenu.hasClass('ecs_open')) {
          $('[data-ecs-parent-element]').each(function () {
            $(this).find('.ecs_accordion').first().removeClass('ecs_open')
          })
          // parent.parentMenu.removeClass('ecs_open')
          parent.blur()
        } else {
          $('[data-ecs-parent-element]').each(function () {
            $(this).find('.ecs_accordion').first().removeClass('ecs_open')
          })
          parent.parentMenu.addClass('ecs_open')
        }
      }

      parent.click(function (event) { // User Clicks a menu item
        if (COMPONENTS.isTouchDevice() && viewportLaptop.matches) {
          parent.toggle()
        }
      })

      parent.parentLink.click(function (event) { // User Clicks a menu item LINK
        if (COMPONENTS.isTouchDevice() && viewportLaptop.matches) {
          event.preventDefault()
          parent.toggle()
        }
      })
    })

    this.$menuParents.closeAll = function () {
      this.each(function () {
        const parent = this
        parent.parentMenu.removeClass('ecs_open')
      })
    }

    this.setMenuOpenHeight = function () {
      const utilityMenu = this.$component.find('[data-ecs-element="utility-menu"]')
      const topBar = this.$component.find('[data-ecs-element="top-bar"]')
      const menuDrawer = this.$component.find('[data-drawer-wrap]')

      var $drawerHeight = (window.innerHeight - utilityMenu.outerHeight() - topBar.outerHeight()) + 'px'

      menuDrawer.css('max-height', $drawerHeight)
    }

    this.toggleMenu = function ($menu, $request) {
      const menu = $menu.attr('data-control-drawer')
      const $menuButtons = $('[data-control-drawer="' + menu + '"]')
      let scrollTop = $('html').scrollTop()

      this.setMenuOpenHeight()

      if ($request == 'close') {
        scrollTop = parseInt($('html').css('top'))

        $menuButtons.each(function () {
          $(this).attr('aria-expanded', false)
        })

        this.$component.find('[data-drawer-wrap][data-drawer="' + menu + '"]').removeClass('ecs_open')
        $('html').removeClass('ecs_menu_open')
        $('html,body').scrollTop(-scrollTop)
      } else {
        $menuButtons.each(function () {
          $(this).attr('aria-expanded', function (i, attr) {
            return attr == 'true' ? 'false' : 'true'
          })
        })

        this.$component.find('[data-drawer-wrap][data-drawer="' + menu + '"]').toggleClass('ecs_open')
        if (!$menu.hasClass('ecs_nearby_button')) { // don't apply open class for Nearby Communities button
          $('html').toggleClass('ecs_menu_open')

          if ($('html').hasClass('ecs_menu_open')) {
            $('html').css('top', -scrollTop) // runs when the menu opens
          } else {
            scrollTop = parseInt($('html').css('top'))
            $('html').scrollTop(-scrollTop) // runs when the menu closes
          }
        }
      }
    }

    this.setAccordionOpenHeight = function ($accordion, $load) {
      var accordionId = ''
      if ($load !== false) {
        accordionId = $accordion.attr('data-ecs-accordion')
      } else {
        accordionId = $accordion.attr('data-ecs-control-accordion')
      }
      const accordion = this.$component.find('[data-ecs-accordion="' + accordionId + '"]')
      const content = accordion.children()

      var $contentHeight = function () {
        var totalHeight = 0
        content.each(function () {
          totalHeight = totalHeight + $(this).outerHeight(true)
        })

        return totalHeight + 'px'
      }

      accordion.css('max-height', $contentHeight)
    }

    this.toggleAccordion = function ($accordion) {
      const accordionId = $accordion.attr('data-ecs-control-accordion')
      const accordion = this.$component.find('[data-ecs-accordion="' + accordionId + '"]')
      const accordionButtons = this.$component.find('[data-ecs-control-accordion="' + accordionId + '"]')

      this.setAccordionOpenHeight($accordion)
      accordionButtons.each(function () {
        $(this).toggleClass('ecs_open')
        $(this).attr('aria-expanded', function (i, attr) { // toggle the aria-expanded state of the control
          return attr == 'true' ? 'false' : 'true'
        })
      })
      accordion.toggleClass('ecs_open')
    }

    this.toggleSideDrawer = function ($drawer, $request) {
      const controlAttr = $drawer.attr('data-ecs-control-sidedrawer')
      const drawerAttr = $drawer.attr('data-ecs-menu-child')
      var drawerId = ''
      // Get the ID depending on the input type (either a button or the drawer itself)
      if (typeof controlAttr !== 'undefined' && controlAttr !== false) {
        drawerId = $drawer.attr('data-ecs-control-sidedrawer')
      } else if (typeof drawerAttr !== 'undefined' && drawerAttr !== false) {
        drawerId = $drawer.attr('data-ecs-menu-child')
      }

      const drawer = this.$component.find('[data-ecs-menu-child="' + drawerId + '"]')
      const drawerButtons = this.$component.find('[data-ecs-control-sidedrawer="' + drawerId + '"]')
      const viewportLaptop = window.matchMedia('(min-width: 1024px)')
      var elementOpen = $drawer.data('ecs-element-active')

      this.$menuParents.closeAll()

      if ($request === 'toggle') {
        drawerButtons.each(function () {
          $(this).toggleClass('ecs_open')
          $(this).attr('aria-expanded', function (i, attr) { // toggle the aria-expanded state of the control
            return attr == 'true' ? 'false' : 'true'
          })
        })
        drawer.children('[data-ecs-sidedrawer]').toggleClass('ecs_open')

        if (viewportLaptop.matches) {
          drawer.stop(true, true).animate({ opacity: 'toggle' }, 300, 'swing', function () { $drawer.attr('data-ecs-element-active', !elementOpen) })
        }
      } else if ($request === 'open') {
        if (!elementOpen && viewportLaptop.matches) {
          drawerButtons.each(function () {
            $(this).addClass('ecs_open')
            $(this).attr('aria-expanded', true) // set the aria-expanded state of the control to true (open)
          })
          drawer.stop(true, true).animate({ opacity: 'show' }, 300, 'swing', function () { drawer.attr('data-ecs-element-active', true) })
        }
      } else if ($request === 'close') {
        if (viewportLaptop.matches) {
          drawerButtons.each(function () {
            $(this).removeClass('ecs_open')
            $(this).attr('aria-expanded', false) // set the aria-expanded state of the control to false (closed)
          })
          drawer.stop(true, true).animate({ opacity: 'hide' }, 300, 'swing', function () { drawer.attr('data-ecs-element-active', false) })
        }
      }
    }

    this.toggleMenuSelect = function ($menuselect, $request) {
      const controlAttr = $menuselect.attr('data-ecs-control-menuselect')
      const drawerAttr = $menuselect.attr('data-ecs-menuselect')
      var selectId = ''
      // Get the ID depending on the input type (either a button or the drawer itself)
      if (typeof controlAttr !== 'undefined' && controlAttr !== false) {
        selectId = $menuselect.attr('data-ecs-control-menuselect')
      } else if (typeof drawerAttr !== 'undefined' && drawerAttr !== false) {
        selectId = $menuselect.attr('data-ecs-menuselect')
      }
      const select = this.$component.find('[data-ecs-menuselect="' + selectId + '"]')
      const selectButtons = this.$component.find('[data-ecs-control-menuselect="' + selectId + '"]')
      var elementOpen = select.data('ecs-element-active')

      this.$menuParents.closeAll()

      if ($request === 'toggle') {
        selectButtons.each(function () {
          $(this).toggleClass('ecs_open')
          $(this).attr('aria-expanded', function (i, attr) { // toggle the aria-expanded state of the control
            return attr == 'true' ? 'false' : 'true'
          })
        })
        select.toggleClass('ecs_open')
        select.attr('data-ecs-element-active', !elementOpen)
      } else if ($request === 'open') {
        selectButtons.each(function () {
          $(this).addClass('ecs_open')
          $(this).attr('aria-expanded', true) // set the aria-expanded state of the control to true
        })
        select.addClass('ecs_open')
        select.attr('data-ecs-element-active', true)
      } else if ($request === 'close') {
        selectButtons.each(function () {
          $(this).removeClass('ecs_open')
          $(this).attr('aria-expanded', false) // set the aria-expanded state of the control to false
        })
        select.removeClass('ecs_open')
        select.attr('data-ecs-element-active', false)
      }
    }

    // Close desktop drawer/select elements based on hover state, with timeouts to facilitate mouse transitions
    this.hoverMouseOut = function (element) {
      const component = this
      const type = $(element).data('ecs-hover-type')
      const hoverID = $(element).data('ecs-hover-id')

      // Determine whether the current hovered element matches the triggering element
      var hovered = function () {
        const hoveredContent = $('[data-ecs-hover-id="' + hoverID + '"]:hover')

        if (hoveredContent.length >= 1) {
          return true
        } else {
          return false
        }
      }

      // Set timeout, close content if no longer hovered
      setTimeout(function () {
        if (!hovered() && viewportLaptop.matches) {
          if (type === 'drawer') {
            component.toggleSideDrawer($('[data-ecs-menu-child][data-ecs-hover-id="' + hoverID + '"]'), 'close')
          } else if (type === 'select') {
            component.toggleMenuSelect($('[data-ecs-menuselect][data-ecs-hover-id="' + hoverID + '"]'), 'close')
          }
        }
      }, 250)
    }

    this.menuResets = function () {
      const component = this

      if ($('html').hasClass('ecs_menu_open')) { // close the main menu if open on rotate event
        $('[data-control-drawer="corporate-menu"]').click()
      }
      $(component).find('.ecs_open').removeClass('.ecs_open')
      $(component).find('.ecs_active').removeClass('.ecs_active')
      $(component).find('[aria-expanded]').attr('aria-expanded', false)
      component.setMenuOpenHeight()
      $(component.$accordionElems).each(function () {
        component.setAccordionOpenHeight($(this))
      })
      $('[data-ecs-menu-child="markets"]').css('display', '') // removes the display:none style which may have been added by .slideUp function
    }

    ComponentMenu.prototype.init = function () {
      const component = this
      const utilityBanner = $('[data-ecs-components-control="utility-inner"]')
      const utilityBannerLine = $('[data-ecs-components-control="utility-line"]')
      const utilityBannerToggle = $('[data-ecs-components-control="utility-toggle"]')
      const viewportLaptop = window.matchMedia('(min-width: 1024px)')

      // Set the menu drawer height on load (to facilitate transition animation)
      component.setMenuOpenHeight()

      // If screen rotates, reset the menu states
      $(window).on('orientationchange', function () {
        component.menuResets()
      })
      $(window).on('resize', function () {
        if (!viewportLaptop.matches && COMPONENTS.isTouchDevice()) {
          component.menuResets()
        }
        component.setMenuOpenHeight()
      })
      $('[data-ecs-components-control="cookiebanner-toggle"]').click(component.setMenuOpenHeight())

      // Set each Accordion content height on load (to facilitate transition animation)
      component.$component.find('[data-ecs-accordion]').each(function () {
        component.setAccordionOpenHeight($(this))
      })

      // Drawer buttons/controls on click
      component.$component.find('[data-control-drawer]').click(function () {
        const viewportLaptop = window.matchMedia('(min-width: 1024px)')
        if (!viewportLaptop.matches) {
          component.toggleMenu($(this))
        }
      })

      // Nearby Properties menu on hover
      component.$component.find('[data-ecs-nearbymenu-hover]').mouseenter(function () {
        const toggleButton = $(this).find('[data-control-drawer="nearby-menu"]')
        if (viewportLaptop.matches) {
          component.toggleMenu(toggleButton)
        }
      })

      component.$component.find('[data-ecs-nearbymenu-hover]').mouseleave(function () {
        const viewportLaptop = window.matchMedia('(min-width: 1024px)')
        const toggleButton = $(this).find('[data-control-drawer="nearby-menu"]')
        if (viewportLaptop.matches) {
          component.toggleMenu(toggleButton)
        }
      })

      // Accordion buttons/controls on click
      component.$component.find('[data-ecs-control-accordion]').click(function () {
        component.toggleAccordion($(this), 'toggle')
      })

      // Side-Drawer buttons/controls on click
      component.$component.find('[data-ecs-control-sidedrawer]').click(function () {
        const viewportLaptop = window.matchMedia('(min-width: 1024px)')
        if (!viewportLaptop.matches || COMPONENTS.isTouchDevice()) {
          component.toggleSideDrawer($(this), 'toggle')
        }
      })

      // Menu Select buttons/controls on click
      component.$component.find('[data-ecs-control-menuselect]').click(function () {
        component.toggleMenuSelect($(this), 'toggle')
      })

      // Menu Select controls on mouseenter
      component.$component.find('[data-ecs-control-menuselect]').mouseenter(function () {
        const viewportLaptop = window.matchMedia('(min-width: 1024px)')
        if (viewportLaptop.matches && !COMPONENTS.isTouchDevice()) {
          component.toggleMenuSelect($(this), 'open')
        }
      })

      // Hover to open child menu items at desktop (where JS required, ex: Communities Menu)
      component.$component.find('[data-ecs-menu-desktophover]').mouseenter(function () {
        const viewportLaptop = window.matchMedia('(min-width: 1024px)')
        if (viewportLaptop.matches && !COMPONENTS.isTouchDevice()) {
          component.toggleSideDrawer($(this), 'open')
        }
      })

      // Menu Select/Drawer mouseleave
      component.$component.find('[data-ecs-menu-desktophover]').mouseleave(function () {
        component.hoverMouseOut($(this))
      })

      component.$component.find(utilityBannerToggle).click(function () {
        utilityBanner.toggle()
        utilityBannerLine.toggle()
      })

      $(document).click(function (event) { // Close elements that require closed when other elements are clicked
        const $target = $(event.target)
        const $nearbyCommunitiesMenu = $('[data-ecs-nearbymenu-hover]')
        const $nearbyButtons = $('[data-control-drawer="nearby-menu"]')

        if (($nearbyButtons.first().attr('aria-expanded') == 'true') && ($target != $nearbyCommunitiesMenu) && ($nearbyCommunitiesMenu.has($target).length == 0)) {
          component.toggleMenu($nearbyButtons.first(), 'close')
        }
      })
    }
  }

  return ComponentMenu
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.componentMenu = new COMPONENTS.ComponentMenu()
  COMPONENTS.componentMenu.init()
})
